

export const PROFILE_UI_CONTENT = {
  PROFILE_CREATED_BY: {
    title: "Who Is Creating This Profile?",
    subtitle: "Please select who is creating and managing this profile.",
  },

  NAME_EMAIL: {
    title: "{subject} Name & Contact Details",
    subtitle: "{instruction}",
  },

  GENDER: {
    title: "Gender",
    subtitle: "{instruction}",
  },

   DOB_DATE: {
    title: "When Were You Born?",
    subtitle: "{instruction}",
  },

  DOB_TIME: {
    title: "{subject} Birth Time",
    subtitle: "{instruction}",
  },

  MARITAL_STATUS: {
    title: "{subject} Marital Status",
    subtitle: "{instruction}",
  },

  CHILDREN: {
    title: "Children Details",
    subtitle: "{instruction}",
  },

  HEIGHT: {
    title: "Height",
    subtitle: "{instruction}",
  },

EDUCATION: {
  title: "Education Details",
  subtitle: "{instruction}",
},

PROFESSION: {
  title: "{subject} Professional Details",
  subtitle: "{instruction}",
},

LIVING_IN: {
  title: "{subject} Current Place of Residence",
  subtitle: "{instruction}",
},

  NATIVE_PLACE: {
    title: "Native Location",
    subtitle: "{instruction}",
  },

  COMMUNITY: {
    title: "Community Details",
    subtitle: "{instruction}",
  },

  
  PARENTS_INFO: {
  title: "About Parents",
  subtitle:
    "Providing parents’ information helps potential matches understand family background.",
},

FAMILY_BACKGROUND: {
  title: "Family Background",
  subtitle:
    "Add information about your family to help others understand your background.",
},

SIBLINGS: {
  title: "About Siblings",
  subtitle:
    "This information helps families get a clearer picture of your family and improves profile authenticity.",
},

ABOUT_FAMILY: {
  title: "About Family",
  subtitle: "Write a few lines about family background and values.",
},

ABOUT_ME_PARTNER: {
  title: "{subject} & Partner Preferences",
  subtitle:
    "{instruction}",
},

ABOUT_ME: {
  title: "About Me",
  subtitle: "{instruction}",
},

ABOUT_PARTNER: {
  title: "About My Partner",
  subtitle: "{instruction}",
},

INFO_FAMILY_OPTIONAL: {
  title: "",
  subtitle: "{instruction}",
},


PHOTO_UPLOAD: {
  title: "Upload Profile Photo",
  subtitle: "{instruction}",
},

  PRIVACY: {
    title: "Privacy Setting",
    subtitle: "{instruction}",
  },



};
